<template>
  <div v-if="showButton" class="back-to-top" @click="scrollToTop">
    <!-- <img v-if="intType==0" src="/assets/img/Main/backTop.png" > -->
    <img src="/assets/img/Main/goBlot.png" >
  </div>
</template>

<script>
export default {
  props: {
    intType: {
      type: Number,
      default: 0 // 默认值
    },
    intBlotTop: {
      type: Number,
      default: 0 // 默认值
    }
  },
  data() {
    return {
      showButton: false, // 控制按钮显示与隐藏
    };
  },
  methods: {
    // 滚动到页面顶部
    scrollToTop() {
      window.scrollTo({ top: this.intBlotTop, behavior: 'smooth' });
    },
    // 监听滚动事件
    handleScroll() {
      if (window.scrollY > 50) {
        this.showButton = true; // 显示按钮
      } else {
        this.showButton = false; // 隐藏按钮
      }
    },
  },
  mounted() {
    // 在组件加载后添加滚动监听
    window.addEventListener('scroll', this.handleScroll);
  },
  beforeDestroy() {
    // 在组件销毁之前移除滚动监听
    window.removeEventListener('scroll', this.handleScroll);
  },
};
</script>

<style scoped>
.back-to-top {
  cursor: pointer;
  width: 2.8rem;
  height: 2.8rem;
  padding: 0.5rem;
  background-color: #21211F;
  position: fixed;
  right: 5rem;
  bottom: 30rem;
  /* display: none; */
}

.back-to-top img {
  width: 1.6rem;
  height: 1.6rem;
}

.back-to-top:hover {
  background-color: #FCB42E;
}

@media (max-width: 768px) {
  .back-to-top {
    display: none;
  }
}
</style>
